export const MAIN_NUMBER = '(844) 902-2842';

export const PAYMENTS_PHONE = '(208) 572-9978';

export const TITLES_PHONE = '(855) 676-1161';
